import { UPDATE_INTERNAL_CHAT_MESSAGING_INFO, INTERNAL_CHAT_CONTACTS } from '../../../../helpers/internalChatConstants';
import { messagesService } from '../../../../newServices/corporateChat';
import { getLastMessagePreview } from '../../../../utils/internalAttachments';

export const addTemporaryMessage = (contacts, message ) => {
    return {
        type: INTERNAL_CHAT_CONTACTS,
        contacts: contacts.map(contact => {
            if(contact.userId === message.userReceiver.userId){
                return {
                    ...contact,
                    dateLastMessage: message.createdAt,
                    lastMessage: getLastMessagePreview(message.messageText, message.attachments),
                    messages: [
                        ...contact.messages,
                        message
                    ]
                }
            }
            return contact;
        })
    };
};

export const removeMessageFromList = () => {
    return {
        type: UPDATE_INTERNAL_CHAT_MESSAGING_INFO,
        data: ''
    }
}

export const sendMessageRequest = (message, activeChat, files) => {
    /** O payload é montado a partir da mensagem otimista, mas só com os campos que a
     *  API espera (`order`, `messageText`, `externalReference`). O restante do objeto
     *  (`userReceiver`, `isSent`, `attachments`...) é estado de UI e não vai no envio.
     */
    return messagesService.postMessagesSend({
        usersDestination: [activeChat.user.userId],
        messages: [{
            order: 0,
            messageText: message.messageText,
            externalReference: message.externalReference
        }],
        files: files
    })
        .then(res => res)
        .catch(error => error);
}

/** Quando o envio devolve só os identificadores, buscamos a mensagem para obter os
 *  anexos já persistidos e exibi-los na bolha sem esperar um reload.
 */
export const resolveSendedAttachments = (sendedMessage, files) => {
    if (!files || files.length === 0) return Promise.resolve(null);
    if (sendedMessage && sendedMessage.attachments && sendedMessage.attachments.length > 0) {
        return Promise.resolve(sendedMessage.attachments);
    }

    const messageId = sendedMessage && (sendedMessage.messageId || sendedMessage.id);
    if (!messageId) return Promise.resolve(null);

    return messagesService.getMessageById(messageId)
        .then(res => (res && res.data && res.data.attachments && res.data.attachments.length > 0) ? res.data.attachments : null)
        .catch(() => null);
}

/** O caminho de falha não pode reusar `updateMessageStatus`: aquele recebe a lista de
 *  mensagens devolvida pela API (e faz `.find`), enquanto aqui só existe a mensagem
 *  otimista. Antes disso, o status de falha só aparecia porque o objeto na store era
 *  mutado antes do `.find` estourar.
 */
export const markMessageAsFailed = (contacts, message) => {
    return {
        type: INTERNAL_CHAT_CONTACTS,
        contacts: contacts.map(contact => {
            if(contact.userId !== message.userReceiver.userId) return contact;
            return {
                ...contact,
                messages: contact.messages.map(msg => {
                    if(msg.externalReference === message.externalReference){
                        return {
                            ...msg,
                            messageStatus: 3
                        }
                    }
                    return msg;
                })
            }
        })
    };
}

export const updateMessageStatus = (contacts, message, attachments) => {
    return {
        type: INTERNAL_CHAT_CONTACTS,
        contacts: contacts.map(contact => {

            const messageData = message.find(m => m.toUserId === contact.userId);
            if(typeof messageData !== "undefined" && contact.userId === messageData.toUserId){
                return {
                    ...contact,
                    messages: contact.messages.map(msg => {
                        if(msg.externalReference === messageData.externalReference){
                            return {
                                ...msg,
                                messageStatus: messageData.messageStatus,
                                id: messageData.messageId,
                                /** Sem os anexos persistidos a bolha manteria o registro local
                                 *  (sem `storageName`, portanto não clicável), em vez de sumir.
                                 */
                                attachments: attachments || msg.attachments
                            }
                        }
                        return msg;
                    })
                }
            }
            return contact;
        })
    };
}
